export default __webpack_public_path__ + "static/media/Rockwool-Blanket.d722c992.jpg";